import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function TakeSupervisorModuleQuestion(props) {
  function handleClick(e) {
    if (e.target.id === "yes") {
      props.handleWillTakeSupervisorModuleChange(true);
    } else {
      props.handleWillTakeSupervisorModuleChange(false);
    }
  }

  return (
    <>
      <Form.Group>
        <Row>
          <Col xs={6}>
            <Form.Label inline="true">
              Are you in a leadership only role?
            </Form.Label>
          </Col>
          <Col xs={6}>
            <Form.Check
              onClick={handleClick}
              inline="true"
              label="yes"
              type="radio"
              name="supervisorRadios"
              id="yes"
            />
            <Form.Check
              onClick={handleClick}
              inline="true"
              label="no"
              type="radio"
              name="supervisorRadios"
              id="no"
            />
          </Col>
        </Row>
        {props.willTakeSupervisorModule === false && (
        <p style={{ color: "green", fontWeight: "bold" }}>
          <span role="img" aria-label="green checkmark">
            ✔️
          </span>{" "}
          You will be attending field based training.
        </p>
      )}
      </Form.Group>
    </>
  );
}

export default TakeSupervisorModuleQuestion;
